// @flow

import { graphql } from 'react-relay';
import { ConnectionHandler } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation AddWarehouseLocationMutation(
    $input: AddWarehouseLocationInput!
  ) {
    addWarehouseLocation(input: $input) {
      warehouseLocationEdge {
        cursor
        node {
          id
          name
          code
          description
          isActive
          updatedAt
          createdAt
        }
      }
    }
  }
`;

export default {
  commit: (options: *) => {
    return createRelayMutation(mutation, {
      ...options,
      updater: store => {
        const newEdge = store
          .getRootField('addWarehouseLocation')
          .getLinkedRecord('warehouseLocationEdge');

        const root = store.getRoot();
        const conn = ConnectionHandler.getConnection(
          root,
          'PaginatedWarehouseLocationsContainer_warehouseLocations',
        );

        if (conn) {
          ConnectionHandler.insertEdgeBefore(conn, newEdge);
        }
      },
    });
  },
};
